"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.track = exports.initialize = exports.ClientTrackingEventTypes = void 0;
const GoogleUtil = require("./GoogleUtil");
const FacebookUtil = require("./FacebookUtil");
var ClientTrackingEventTypes;
(function (ClientTrackingEventTypes) {
    ClientTrackingEventTypes["Purchase"] = "Purchase";
})(ClientTrackingEventTypes = exports.ClientTrackingEventTypes || (exports.ClientTrackingEventTypes = {}));
;
function initialize(clientTrackingIds) {
    GoogleUtil.initialize(clientTrackingIds.googleAnalyticsId);
    FacebookUtil.initialize(clientTrackingIds.facebookPixelId);
}
exports.initialize = initialize;
function track(type, params) {
    switch (type) {
        case ClientTrackingEventTypes.Purchase:
            return trackPurchase(params);
        default:
            return null;
    }
}
exports.track = track;
function trackPurchase({ order, orderTotal, channel, currency = 'USD', }) {
    GoogleUtil.track('event', 'purchase', {
        transaction_id: order._id,
        value: orderTotal / 100,
        affiliation: channel,
        currency,
    });
    FacebookUtil.track('track', 'Purchase', {
        value: orderTotal / 100,
        currency,
    });
}
//# sourceMappingURL=ClientTrackingUtil.js.map